<template>
  <el-select
    ref="asyncSelect"
    v-model="ids"
    v-loadmore="loadMore"
    class="agency-select"
    filterable
    multiple
    value-key="supplierId"
    remote
    :remote-method="remoteMethod"
    clearable
    :loading="loading"
    v-bind="$attrs"
    @focus="focus"
    @clear="clear"
    v-on="$listeners"
  >
    <el-option
      v-for="item in options"
      :key="item.supplierId"
      :label="item.supplierName"
      :value="item.supplierId"
    >
      {{ item.supplierName }}
    </el-option>
    <!-- 此处加载中的value可以随便设置，只要不与其他数据重复即可 -->
    <el-option v-if="more" disabled label="加载中..." value="-1" />
  </el-select>
</template>

<script>
import { getRiskPortraitTradeListApi } from '@/api/risk/portrait'
import { mapState } from 'vuex'

export default {
  name: 'SupplierAsyncSelect',

  model: {
    prop: 'companyIds',
    event: 'change'
  },

  props: {
    companyIds: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  data() {
    return {
      options: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      keyword: '', // 存储关键字用
      more: true
    }
  },

  computed: {
    ...mapState('company', ['companyId']),

    ids: {
      get() {
        return this.companyIds
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },

  methods: {
    // 请求下一页的数据
    loadMore() {
      // 如果没有更多数据，则不请求
      if (!this.more) {
        return
      }

      // 如果intercept属性为true则不请求数据
      if (this.loadMore.intercept) {
        return
      }
      this.loadMore.intercept = true
      this.page += 1
      this.getAsyncList({
        page: this.page,
        keyword: this.keyword,
        more: true
      }).then(() => {
        this.loadMore.intercept = false
      })
    },

    // 执行远程搜索
    remoteMethod(query) {
      this.keyword = query
      this.loading = true
      this.getAsyncList({ keyword: query, page: 1 }).then(() => {
        this.loading = false
      })
    },

    focus() {
      if (!this.options.length) {
        this.page = 1
        this.getAsyncList({ page: 1 })
      }
    },

    clear() {
      if (this.keyword) {
        this.keyword = ''
        this.getAsyncList({ page: 1 })
      }
    },

    getAsyncList({ page = 1, keyword = '', more = false } = {}) {
      return new Promise(resolve => {
        const params = {
          page: page,
          size: this.size,
          supplierName: keyword
        }
        getRiskPortraitTradeListApi(params)
          .then(res => {
            const records = res.data?.records || []
            this.total = res.data?.total || 0
            if (more) {
              this.options = this.options.concat(records)
            } else {
              this.options = records
            }

            this.more = page * this.size < this.total
            resolve()
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.agency-select {
  width: 500px;
}
</style>
